import { gridSizeMdLg12, gridSizeMdLg3, sanitizeTodos, useTableServerSideFiltering } from "@/shared"
import { CustomAutocompleteNoForm, GeneralTable, SearchComponente, } from "@/shared/components/ui"
import { Button, Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import useTableColumnsReporteCompra from "../../hooks/useTableColumnsReporteCompra"
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { MaterialReactTable } from "material-react-table"
import { useGetFetchReporteCompra } from "@/shared/actions/erp/reporte-compra/reporte-factura.actions"
import { EnumChoiceOptions } from "../../types/reporte-compra.interface"
import useTableFilterMulti from "@/shared/hooks/useTableFilterMulti"
import { useRef, useState } from "react"

import { RiFileExcel2Fill } from "react-icons/ri";

import { BsBarChartLineFill } from "react-icons/bs";
import { useGetReporteIngresosProductosExcel } from "@/shared/actions/erp/compras/reporte-comnpra.actions"
import { useAuthStore } from "@/store/auth"
import { useUiStore } from "@/store/ui"
import { toast } from "react-toastify"
import { useModalReporteCompraStore } from "@/store/erp/reporte-compra/reporte-compra-store"
import ScrollDialogReporte from "@/shared/components/ui/scrollDialogReporte/scrollDialogReporte"
import LoaderLinearProgress from "@/shared/components/ui/LoaderLinear/LoaderLinearProgress"
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker"
import Flatpickr from 'react-flatpickr';
import dayjs from "dayjs"
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm"
import { IDataSerie } from "@/shared/interfaces/erp/administration/productofactorserie.interface"
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch"
import { useForm } from "react-hook-form"
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import CachedIcon from '@mui/icons-material/Cached';
type viewReporteCompraprops = {
  titlePage: string
}
export default function ViewReporteCompra({ titlePage }: viewReporteCompraprops) {

  const email = useAuthStore.getState().user?.email ?? ''
  const flatpickrRef = useRef<Flatpickr>(null);

  //const isGlobalLoading = useUiStore.getState().isGlobalLoading
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading
  const isOpenModal1 = useModalReporteCompraStore(s => s.isOpen)
  const setIsOpenModal1 = useModalReporteCompraStore(s => s.setIsOpen)
  const [searchTermOption, setSeacrchOptions] = useState('')


  const {
    pagination,
    setPagination,
    onChangeFilter1,
    globalFilters1,
    searchTerms1
  } = useTableFilterMulti()


  const { pageIndex, pageSize } = pagination


  const {
    columnFilters,
    setColumnFilters,
    filterObject
  } = useTableServerSideFiltering()

  const {
    fetchAutocompleteSerie
  } = useAutocompleteFetch()

  const form = useForm<any>({
    defaultValues: {
      serie: null,
      fecha_hasta: dayjs().format('YYYY-MM-DD'),
      fecha_desde: dayjs().subtract(30, 'day').format('YYYY-MM-DD')
    }
  });

  const {
    control,
    reset
  } = form;

  //  Normaliza los filtros: "ingreso.numero_guia_remision" → "numero_guia_remision"
  const normalizeFilters = (filters: Record<string, any>) => {
    const result: Record<string, any> = {}

    Object.entries(filters).forEach(([key, value]) => {
      const cleanKey = key.includes('.') ? key.split('.').pop()! : key
      result[cleanKey] = value
    })

    return result
  }

  const {
    data: reporteCompraResp,
    isLoading: isLoadingReporte,
    isRefetching,
    refetch
  } = useGetFetchReporteCompra({
    page: pageIndex + 1,
    page_size: pageSize,
    //descripcion_producto: searchTerm.toUpperCase(),
    fecha_hasta: form.getValues('fecha_hasta'),
    fecha_desde: form.getValues('fecha_desde'),
    serie: sanitizeTodos(form.getValues('serie')),
    ...searchTerms1,
    ...normalizeFilters(filterObject),
    ...filterObject,
    filterByState: false
  })


  const {
    columnsReporteCompra,
    isOpenModal, setIsOpenModal,
    details,
    columnsSeries
  } = useTableColumnsReporteCompra()

  const options = Object.entries(EnumChoiceOptions).map(([value, label]) => ({
    value, label
  }))

  const {
    //data: dataIngresosProductosExcel,
    //isLoading: isLoadingExcel,
    refetch: refetchExcel
  } = useGetReporteIngresosProductosExcel({
    //page: 600,
    email: email,
    serie: form.getValues('serie')?.serie,
    fecha_hasta: form.getValues('fecha_hasta'),
    fecha_desde: form.getValues('fecha_desde')
  },
    false
  )

  const handleDowload = async () => {
    try {
      setIsGlobalLoading(true);

      const data = await refetchExcel(); // espera a que termine la petición

      if (data?.data?.code === 200) {
        setIsOpenModal1(true)
        //toast.success('Se generó exitosamente');
      } else {
        toast.error('Ocurrió un error al generar el Excel');
      }

    } catch (error) {
      toast.error('Error al descargar el Excel');
    } finally {
      setIsGlobalLoading(false);
    }
  };


  //if (isLoadingReporte) return <LoaderComponent />

  return (

    <>
      <Grid container spacing={3} alignItems="center">
        <Grid item {...gridSizeMdLg12}>
          <Stack direction="row" alignItems="center" spacing={1}>
            < BsBarChartLineFill size={45} color="#3b7979ff" />
            <Typography variant="h4">{titlePage}</Typography>
          </Stack>

        </Grid>


        <Grid item {...gridSizeMdLg12}>
          <Grid
            container
            spacing={3}
            alignItems="center"
            justifyContent="end" // o "flex-end" si los quieres a la derecha
          >

            <Grid item {...gridSizeMdLg3}>
              <SearchComponente
                value={globalFilters1[searchTermOption] || ""}
                text="por items seleccionado"
                onChange={(value) => onChangeFilter1(searchTermOption, value)}
              />

            </Grid>


            <CustomAutocompleteNoForm
              size={gridSizeMdLg3}
              label="Tipo de búsqueda"
              options={options || []}
              //options={[{ label: '- Todos -', value: '' }, ...(options || [])]}
              valueKey={'label'}
              actualValueKey={'value'}
              defaultValue={''} // valor por defecto
              isLoadingData={false}
              onChangeValue={(value) => {
                if (value !== searchTermOption) {
                  // Limpio el filtro anterior
                  onChangeFilter1(searchTermOption, '');
                  // Seteo el nuevo tipo de búsqueda
                  setSeacrchOptions(value);
                } else {
                  // Si es el mismo valor, solo lo seteo (o nada)
                  setSeacrchOptions(value);
                }

              }}
            />

            <CustomAutocompleteFetchForm<IDataSerie>
              required={false}
              control={control}
              size={gridSizeMdLg3}
              name="serie"
              label="Buscar por serie"
              fetchData={fetchAutocompleteSerie}
              //isAll={true}
              getOptionLabel={(opt) => opt.serie || ''}
              key={'autocomplete-serie'}
              getOptionKey={(o) => o.serie!}
              keySearch="serie"
              onChangeValue={(e) => {
                
                reset({
                  ...form.getValues(),
                  serie: e
                })

                if (e) {
                  setPagination({
                    pageIndex: 0,
                    pageSize: 10,
                  })
                }

              }}
            />

            <DateRangePicker
              size={gridSizeMdLg3}
              flatpickrRef={flatpickrRef}
              defaultValue={[form.getValues('fecha_hasta'), form.getValues('fecha_desde')]}
              onChange={(range) => {
                console.log(range);
                if (range.length == 2) {
                  reset({
                    ...form.getValues(),
                    fecha_hasta: dayjs(range[1]).format('YYYY-MM-DD'),
                    fecha_desde: dayjs(range[0]).format('YYYY-MM-DD')
                  })
                }
              }}
            />

            <Grid item >
              <Tooltip title="Generar Excel">
                <Button
                  variant="contained"
                  endIcon={<RiFileExcel2Fill />}
                  //onClick={() => refetchExcel()}
                  onClick={() => handleDowload()}
                  color="success"
                >
                  {'Generar Excel'}
                </Button>

              </Tooltip>

            </Grid>

            <Grid item >
              <Tooltip title="Actualizar datos">
                <Button
                  //onClick={() => refetchExcel()}
                  endIcon={<CachedIcon />}
                  onClick={() => refetch()}
                  color="primary"
                  variant="contained"
                >
                  {'Actualizar'}
                </Button>

              </Tooltip>

            </Grid>

            <Grid item >
              <Tooltip title="Limpiar filtros">
                <IconButton
                  onClick={() => {
                    reset({
                      serie: null,
                    })

                    onChangeFilter1('', '')
                    setSeacrchOptions('')
                    flatpickrRef.current?.flatpickr.clear();

                  }}
                >
                  <FilterAltOffIcon />
                </IconButton>

              </Tooltip>
            </Grid>
          </Grid>

        </Grid>
        <Grid item {...gridSizeMdLg12}>
          {isLoadingReporte && (
            <LoaderLinearProgress />
          )}
        </Grid>

        <Grid item {...gridSizeMdLg12}>
          <GeneralTable
            density="compact"
            columns={columnsReporteCompra}
            data={reporteCompraResp?.data.data || []}
            isLoading={isLoadingReporte}
            isRefetching={isRefetching}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={reporteCompraResp?.data.count}
            enableEditing={false}
            enableGlobalFilter={false}
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={(value) => {
              setColumnFilters(value)
              setPagination({
                pageIndex: 0,
                pageSize: 10,
              })
            }}
            enableSorting={false}
          />
        </Grid>
      </Grid>

      <ScrollableDialogProps
        open={isOpenModal}
        title={`Total de Series: ${details.length}`}
        onCloseIcon={() => setIsOpenModal(false)}
        minWidth="50%"
        contentNode={
          <Grid>
            <MaterialReactTable<any>
              columns={columnsSeries}
              data={details}
              enableHiding={false}
              enableFullScreenToggle={false}
              enableDensityToggle={false}
              enableGlobalFilter={true}
              initialState={{ density: 'compact' }}
            />
          </Grid>
        }
      />
      <ScrollDialogReporte
        isOpen={isOpenModal1}
        setIsOpenModal={setIsOpenModal1}
        title="Generación de reporte completada. !"
        subtitulo={` Revisa tu bandeja de entrada 📧, el reporte de compras ha sido enviado a: ${email}`}
      />
    </>
  )
}